.chart {
  display: flex;
  flex-direction: row;
  gap: var(--tuna-spacing-1);
  width: 100%;
  min-height: 96px;
  padding: var(--tuna-spacing-2) 0;
}

.block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--tuna-spacing-1);
  padding: var(--tuna-spacing-3);
  border: none;
  border-radius: var(--tuna-shape-borderRadius);
  cursor: pointer;
  color: var(--tuna-content-onSection);
  font-family: inherit;
  transition: opacity 150ms ease-in-out;
}

.chart[data-has-active='true'] .block {
  opacity: 0.5;
}

.chart[data-has-active='true'] .block[aria-current='step'] {
  opacity: 1;
  outline: 4px solid var(--tuna-focus-ring);
  outline-offset: -4px;
}

.block:hover {
  outline: 2px solid var(--tuna-focus-ring);
}

.blockLabel {
  font-size: var(--tuna-typography-body1-fontSize);
  font-weight: 600;
}

.blockBars {
  font-size: var(--tuna-typography-caption-fontSize);
  opacity: 0.9;
}

@media (prefers-reduced-motion: reduce) {
  .block {
    transition: none;
  }
}
